import { render, staticRenderFns } from "./AccountingAccountsAffectation.vue?vue&type=template&id=2820bb11&scoped=true&"
import script from "./AccountingAccountsAffectation.vue?vue&type=script&lang=js&"
export * from "./AccountingAccountsAffectation.vue?vue&type=script&lang=js&"
import style0 from "./AccountingAccountsAffectation.vue?vue&type=style&index=0&id=2820bb11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820bb11",
  null
  
)

export default component.exports